import UserListSection from "../components/UserListSection";
import { useAuth } from "../hooks/useAuth";

export default function Users() {
  const { user } = useAuth();

  return (
    <div className="flex grow flex-col items-center">
      {/* Users */}
      <div className="flex mt-10 w-full lg:w-3/4">
        <UserListSection />
      </div>
    </div>
  );
}
